export default {
  indexEndpoint: '/customerAccess/',
  storeEndpoint: '/customer-access',
  editEndpoint: '/customer-access/',
  updateEndpoint: '/customer-access/',
  deleteEndpoint: '/customer-access/',
}
